import type { JSX } from '@builder.io/qwik';
import { useContextProvider } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import { cva } from 'class-variance-authority';
import {
  getCSSColorBg,
  getCSSHeightSmFactor,
  getCSSHeightMdFactor,
  getCSSHeightLgFactor,
  getCSSTopSmFactor,
  getCSSTopMdFactor,
  getCSSTopLgFactor,
} from '~/utilities/getCSS';
import Nav from '~/components/Layout/Header/Desktop/Nav';
import { getScreenSizeObject } from '~/utilities/getScreenSizeObject';
import type { NavThemeComponentsInterface } from '~/types/AppData/Theme/NavThemeComponentsInterface';
import { NavContext } from '~/contexts/NavContext';
import { setStoreItem } from '~/utilities/Store';
import { LAST_LOADED } from '~/constants/LAST_LOADED';

const headerClasses = cva(
  'fixed flex items-center space-between w-full pl-2.5 md:pl-f-1.5 lg:pl-f-2.5 md:pr-f-2 lg:pr-f-1.5 z-40 shadow-header',
  {
    variants: {
      color: getCSSColorBg(),
      heightSm: getCSSHeightSmFactor(),
      heightMd: getCSSHeightMdFactor(),
      heightLg: getCSSHeightLgFactor(),
      topSm: getCSSTopSmFactor(),
      topMd: getCSSTopMdFactor(),
      topLg: getCSSTopLgFactor(),
    },
  }
);

export default component$((): JSX.Element => {
  setStoreItem(LAST_LOADED, 'NavRowSecondary');
  const {
    payloadToSSR: {
      layout: { subHeader, header: theHeader },
    },
    themeComponents: { header },
  } = useContext(AppDataContext);

  if (
    (!subHeader?.links?.value.length &&
      !subHeader?.socialLinks?.value.length) ||
    theHeader.secondaryLogo?.value
  )
    return <></>;

  const navTheme = Object.keys(header).reduce(
    (acc, key) => {
      if (key.includes('secondRow')) {
        const newKey = key.replace('secondRow', '');
        acc[newKey] = header[key as keyof typeof header];
      }

      return acc;
    },
    {} as Record<string, any>
  ) as NavThemeComponentsInterface;

  navTheme.ColumnGap = { type: 'FACTOR', value: 1 };

  useContextProvider(NavContext, {
    header: subHeader,
    theme: navTheme,
    hasAccessibility: false,
    navInMobile: true,
  });

  return (
    <div
      class={headerClasses({
        color: header.secondRowBackgroundColor.value,
        ...getScreenSizeObject(header, 'secondRowHeightIn', 'Screen', 'height'),
        ...getScreenSizeObject(header, 'firstRowHeightIn', 'Screen', 'top'),
      })}
    >
      <Nav />
    </div>
  );
});
